<template>
  <div>
    <h4>Welcome to ADAS Map Pro</h4>
  </div>
  <div class="row">
    <div class="col">
      <p></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomePage'
}
</script>
<style lang="scss" scoped></style>
